import { Box } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useUpdateKybPersonMutation } from '../../../services/guenoApi'
import TextInputForm from '../../../components/common/form/TextInputForm/TextInputForm'

const KybPersonEditManualPhoneNumber = ({ initialValue, onSubmit }) => {
  const { t } = useTranslation(['common', 'messages'])
  const [_, { isLoading }] = useUpdateKybPersonMutation({ fixedCacheKey: 'update-subject' })

  const phoneNumberSchema = yup.object().shape({
    CountryCode: yup
      .string()
      .matches(/^\d{2}$/, t('messages:kyb.phoneNumber.areaCode.twoDigits.error'))
      .required(t('messages:kyb.phoneNumber.areaCode.twoDigits.error')),

    AreaCode: yup
      .string()
      .matches(/^\d{2}$/, t('messages:kyb.phoneNumber.areaCode.twoDigits.error'))
      .required(t('messages:kyb.phoneNumber.areaCode.twoDigits.error')),

    Number: yup
      .string()
      .matches(/^\d{8,9}$/, t('messages:kyb.phoneNumber.number.digits.error'))
      .required(t('messages:kyb.phoneNumber.number.digits.error')),
  })

  const {
    control,
    handleSubmit,
    formState: { isDirty, errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(phoneNumberSchema),
    defaultValues: {
      CountryCode: initialValue?.CountryCode || '55',
      AreaCode: initialValue?.AreaCode || '',
      Number: initialValue?.Number || '',
    },
  })

  const handleFormSubmit = (data) => {
    const phoneWithType = { ...data, Type: 'MANUAL' }
    onSubmit({ phoneNumberList: [phoneWithType] })
  }

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Box className="modal-box">
        <Box sx={{ display: 'grid', gridTemplateColumns: '0.5fr 0.5fr 0.5fr', gap: 2 }}>
          <TextInputForm
            name="CountryCode"
            inputMode="numeric"
            control={control}
            label={t('common:countryCode')}
            inputProps={{ maxLength: 2 }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, '')
            }}
          />
          <TextInputForm
            name="AreaCode"
            inputMode="numeric"
            control={control}
            label={t('common:areaCode')}
            inputProps={{ maxLength: 2 }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, '')
            }}
          />
          <TextInputForm
            name="Number"
            inputMode="numeric"
            control={control}
            label={t('common:number')}
            inputProps={{ maxLength: 9 }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, '')
            }}
          />
        </Box>
      </Box>
      <Box className="modal-button">
        <LoadingButton
          size="small"
          color="secondary"
          variant="contained"
          disabled={!isDirty || Object.keys(errors).length > 0}
          type="submit"
          loading={isLoading}
        >
          {t('common:save')}
        </LoadingButton>
      </Box>
    </form>
  )
}

export default KybPersonEditManualPhoneNumber
